import { createOfferMachineHooks } from '@eneco/flows/hooks';

import { FlowContextSme } from '../context';
import { GetOfferEvent, getOfferEventHash } from '../machines/getOffer/getOffer.helpers';
import { getOfferMachine } from '../machines/getOffer/getOffer.machine';
import { SmeOffer } from '../machines/getOffer/getOffer.types';

export const { useOfferMachine, useCachedOfferMachine } = createOfferMachineHooks<
  SmeOffer,
  FlowContextSme,
  GetOfferEvent
>({
  getOfferMachine,
  getOfferEventHash,
});
